/**
 *
 * UpdatePassword
 *
 */
import React, { memo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BoxDesign, Input, NewButton, Modal } from '../AlltypeStyledComponent';
import { P } from '../AtomComponents/P';
import { useParams, useNavigate } from 'react-router-dom';
import useMediaQuery from 'utils/hooks/useMediaQuery';
import api from 'app/api';
import {
  errorModal,
  receiveError,
  successModal,
} from 'utils/showSuccessErrorModal';
import { ErrorInterface } from 'utils/types/success-error-types';

export const UpdatePassword = memo(() => {
  const { t } = useTranslation();
  const { token } = useParams(); // Get the token from the URL
  const isMobile = useMediaQuery('(max-width: 500px)');
  const password = useRef<HTMLInputElement | null>(null);
  const [confirmPassword, setConfirmPassword] = useState('');
  const navigate = useNavigate();

  const onSubmit = async e => {
    e.preventDefault();
    const newPassword = password.current?.value;

    // Basic validation to check if passwords match
    if (newPassword !== confirmPassword) {
      errorModal(t('Passwords do not match!'));
      return;
    }

    // Call the updateBizEmployeePassword API
    try {
      const response = await api.post(
        `/auth/business-employees/update-password`,
        { token, newPassword },
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        },
      );
      if (response.status === 200) {
        successModal(t('Password updated successfully!'));
        navigate('/'); // Redirect to login page after success
      } else {
        alert(t('Error updating password'));
      }
    } catch (error) {
      const apiError = error as ErrorInterface;
      receiveError(apiError?.response?.data);
    }
  };

  return (
    <Modal background='var(--heltar-bg-primary)'>
      <BoxDesign
        padding='50px'
        fontsize='16px'
        width={isMobile ? 'calc(100% - 15px)' : '500px'}
        style={{
          maxHeight: 'calc(var(--app-height, 100vh) - 80px)',
          overflowY: 'auto',
          margin: '65px 0 0 0',
        }}
      >
        <form action='' onSubmit={onSubmit}>
          <label htmlFor='password'>
            <P fontsize='18'>{t('Enter New Password:')}</P>
          </label>
          <Input
            type='password'
            placeholder={t('Enter New Password')}
            width={isMobile ? '90%' : '380px'}
            margin='15px 0'
            required
            ref={password}
          />
          <label htmlFor='confirmPassword'>
            <P fontsize='18' marginbottom='15'>
              {t('Confirm New Password:')}
            </P>
          </label>
          <Input
            type='password'
            placeholder={t('Confirm New Password')}
            width={isMobile ? '90%' : '380px'}
            margin='15px 0'
            required
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
          />
          <br />
          <NewButton type='submit' margintop='10px' width='150px' height='40px'>
            {t('Submit')}
          </NewButton>
        </form>
      </BoxDesign>
    </Modal>
  );
});
